export default "__VITE_ASSET__BAMUbyuF__"